/**
 * size-guide.js — the size guide's two interactive parts.
 *
 * Loaded by `snippets/size-guide-content.liquid`, so it arrives on every
 * surface that renders the guide and on no other: the product page's drawer,
 * and /pages/size-chart. It used to live in product.js, which the standalone
 * page has no reason to load (owner, 2026-09-04: "make sure this page is the
 * same as the popup size guide you just made" — the same includes working).
 *
 * The DRAWER itself is not here. Opening it, trapping focus in it and closing
 * it are product-page concerns and stay in product.js.
 *
 * Everything is delegated off `document` rather than bound on load, because
 * the guide can be re-rendered by a section update and a listener bound to an
 * element that gets replaced stops working silently. Scoping is
 * `[data-size-guide-content]`, the wrapper the snippet emits, so two guides on
 * one page could never drive each other.
 *
 * No library, and nothing runs at all on a page with no size guide.
 */
(function () {
  function sizeGuideTabs(el) {
    var root = el.closest('[data-size-guide-content]');
    return root ? Array.prototype.slice.call(root.querySelectorAll('[data-sg-tab]')) : [];
  }

  function selectSizeGuideTab(tab, moveFocus) {
    var root = tab.closest('[data-size-guide-content]');
    if (!root) return;

    sizeGuideTabs(tab).forEach(function (other) {
      var on = other === tab;
      other.setAttribute('aria-selected', on ? 'true' : 'false');
      /* Roving tabindex: one stop for the whole strip, arrows move within it.
         Without this every tab is a tab stop and the keyboard user pages
         through the control instead of past it. */
      other.tabIndex = on ? 0 : -1;

      var panel = root.querySelector('[data-sg-panel="' + other.dataset.sgTab + '"]');
      if (panel) panel.hidden = !on;
    });

    if (moveFocus) tab.focus();
  }

  document.addEventListener('click', function (event) {
    if (!event.target || typeof event.target.closest !== 'function') return;

    var tab = event.target.closest('[data-sg-tab]');
    if (tab) selectSizeGuideTab(tab, false);
  });

  document.addEventListener('keydown', function (event) {
    var tab = event.target && event.target.closest
      ? event.target.closest('[data-sg-tab]')
      : null;
    if (!tab) return;

    var tabs = sizeGuideTabs(tab);
    var index = tabs.indexOf(tab);
    var next = null;

    if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
      next = tabs[(index + 1) % tabs.length];
    } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
      next = tabs[(index - 1 + tabs.length) % tabs.length];
    } else if (event.key === 'Home') {
      next = tabs[0];
    } else if (event.key === 'End') {
      next = tabs[tabs.length - 1];
    }

    if (!next) return;
    event.preventDefault();
    selectSizeGuideTab(next, true);
  });

  /**
   * Bra size to top size.
   *
   * A cup letter is worth a fixed number of inches over the band — that number
   * is the <option>'s own value, so the letters stay display text and the
   * arithmetic has one home. Band plus cup is the bust measurement, and the
   * answer is the first size whose bust ceiling is not below it.
   *
   * The ceilings come off `data-sg-sizes`, which Liquid writes from the same
   * five rows the table renders, so the calculator cannot answer with a size
   * the table disagrees with.
   *
   * Rounding is deliberately generous. The store's standing advice is to size
   * up when between sizes, so a measurement that falls in the gap between two
   * ranges takes the larger, and a measurement past the last ceiling returns
   * the largest size with a line telling her to write in rather than returning
   * nothing at all.
   */
  function runSizeFinder(finder) {
    var band = finder.querySelector('[data-sg-band]');
    var cup = finder.querySelector('[data-sg-cup]');
    var out = finder.querySelector('[data-sg-result]');
    if (!band || !cup || !out) return;

    var sizes;
    try {
      sizes = JSON.parse(finder.dataset.sgSizes);
    } catch (error) {
      return;
    }
    if (!sizes || !sizes.length) return;

    var bust = parseFloat(band.value) + parseFloat(cup.value);
    if (isNaN(bust)) return;

    var match = null;
    for (var i = 0; i < sizes.length; i++) {
      if (bust <= sizes[i][1]) {
        match = sizes[i][0];
        break;
      }
    }

    var pastTheChart = match === null;
    if (pastTheChart) match = sizes[sizes.length - 1][0];

    var label = band.value + cup.options[cup.selectedIndex].text;
    out.innerHTML = pastTheChart
      ? 'A ' + label + ' is past the top of our chart. We would start you at <strong>' +
        match + '</strong> and we would rather get it right: email hi@koshafit.com and we will help.'
      : 'A ' + label + ' is about a ' + bust + '&quot; bust, so we would suggest a <strong>' +
        match + '</strong> top.';

    /* Point at the row as well as naming it. Cleared across the whole guide
       first so a second run cannot leave two rows marked. */
    var root = finder.closest('[data-size-guide-content]');
    if (!root) return;
    root.querySelectorAll('[data-sg-match]').forEach(function (row) {
      row.removeAttribute('data-sg-match');
    });
    root.querySelectorAll('[data-sg-row="' + match + '"]').forEach(function (row) {
      row.setAttribute('data-sg-match', '');
    });
  }

  document.addEventListener('click', function (event) {
    if (!event.target || typeof event.target.closest !== 'function') return;

    var go = event.target.closest('[data-sg-go]');
    if (!go) return;

    var finder = go.closest('[data-sg-finder]');
    if (finder) runSizeFinder(finder);
  });

  /* Changing a dropdown after an answer is on screen re-runs it, so the result
     can never describe a bra size that is no longer selected. Before the first
     answer it does nothing: the shopper has not asked yet. */
  document.addEventListener('change', function (event) {
    var select = event.target && event.target.closest
      ? event.target.closest('[data-sg-band], [data-sg-cup]')
      : null;
    if (!select) return;

    var finder = select.closest('[data-sg-finder]');
    var out = finder ? finder.querySelector('[data-sg-result]') : null;
    if (finder && out && out.innerHTML !== '') runSizeFinder(finder);
  });
})();
